export const navbarStyles = {
  drawer: {
    flexDirection: "row",
    alignItems: "flex-end",
  },
  listItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
  },
  icons: {
    marginBottom: "2px",
    justifyContent: "center",
    height: "12px",
  },
  text: {
    "& span": {
      fontWeight: "600",
      fontSize: "12px",
      whiteSpace: "nowrap",
      textAlign: "center",
      mt: "4px",
    },
  },
  list: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    p: 0,
    height: "60px",
    background: "#1e1e2d",
  },
  mobile: {},

  desktopDrawer: {
    width: 240,
    flexShrink: 0,
    backgroundColor: "#1e1e2d",
    color: "#9899ac",
    "& .MuiDrawer-paper": {
      width: 240,
      backgroundColor: "#1e1e2d",
      borderRight: "none",
    },
  },
  desktopListItem: {
    "&:hover": {
      backgroundColor: "#f4f7f9",
    },
  },
  logoText: {
    color: "white",
    textAlign: "center",
  },
  divider: {
    backgroundColor: "white",
    width: "90%",
    margin: "auto",
  },
};

export default navbarStyles;
